<div class="bg-white w-[28rem] max-w-[90vw] flex flex-col p-6 rounded-lg gap-4">
    <div class="flex flex-col gap-1 border-b pb-3">
        <span class="text-base font-semibold">อัพเดต Check List พร้อมกัน</span>
        <span class="text-sm text-gray-500">{{ sets.length }} เซ็ตที่เลือก</span>
    </div>

    <div class="flex flex-col w-full text-sm md:text-base">
        @if (channelRows.length > 0) {
        <label class="w-full flex items-center space-x-2 border-b pb-2 mb-3 cursor-pointer">
            <input type="checkbox"
                [checked]="allFullyChecked"
                [indeterminate]="someChecked && !allFullyChecked"
                (change)="toggleAll($any($event.target).checked)" />
            <span class="font-medium">เลือกทั้งหมด</span>
        </label>
        }

        @if (channelRows.length === 0) {
        <div class="text-center text-gray-500 py-6">ไม่พบช่องทางใน Check List</div>
        }

        <div class="flex flex-col gap-3 max-h-[50vh] overflow-y-auto pr-1">
            @for (row of channelRows; track row.channel) {
            <label class="flex items-center justify-between gap-2 cursor-pointer">
                <div class="flex items-center gap-2 min-w-0">
                    <input type="checkbox" [(ngModel)]="row.desiredChecked"
                        [ngModelOptions]="{standalone: true}" />
                    <span class="truncate"
                        [ngClass]="{'line-through text-gray-500': row.desiredChecked}">
                        {{ row.name }}
                    </span>
                </div>
                <span class="text-xs font-medium flex-none"
                    [ngClass]="row.checkedCount === row.totalCount ? 'text-lime-600' : 'text-gray-500'">
                    {{ row.checkedCount }}/{{ row.totalCount }}
                </span>
            </label>
            }
        </div>
    </div>

    <div class="flex justify-end space-x-2 pt-3 border-t">
        <button class="btn-sm btn-light min-w-[6rem]" (click)="close()">ยกเลิก</button>
        <button class="btn-sm btn-primary min-w-[6rem]" [disabled]="channelRows.length === 0"
            (click)="confirm()">อัพเดต</button>
    </div>
</div>
